RivalIQ.module('models', function (models, App, Backbone, Marionette, $, _) {

    'use strict';

    models.Account = Backbone.Model.extend({
        type: 'Account',
        urlRoot: '/api/account',

        adminUrl: function () {
            const me = this;
            return `/admin${me.url()}`;
        },

        getUsers: function () {
            const me = this;

            return RivalIQ.data.users.fetch(me);
        },

        patchSettings: function (settings, options) {
            const me = this;
            options = _.extend({
                validate: true,
                method: 'patch'
            }, options);

            if (!me.set({
                settings: _.extend({}, me.get('settings'), settings)
            }, options)) {
                return false;
            }

            options.attrs = settings;
            options.url = `${me.url()}/settings`;
            options.success = function (resp) {
                const serverAttrs = {
                    settings: resp
                };
                me.set(serverAttrs, options);
                me.trigger('sync', me, resp);
            };

            return (me.sync || Backbone.sync).call(me, 'update', me, options);
        },

        getOwner: function () {
            const me = this;

            const options = {
                url: `${me.url()}/owner`
            };

            return (me.sync || Backbone.sync).call(me, 'read', me, options).then(function (data) {
                me.owner = new RivalIQ.models.User(data.owner);
                return me.owner;
            });
        },

        getAllCompanies: function () {
            const me = this;

            const options = {
                url: `${me.url()}/allCompanies`
            };

            return (me.sync || Backbone.sync).call(me, 'read', me, options).then(function (data) {
                return data;
            });
        },

        getMaxUsers: function () {
            const me = this;
            return me.get('plan').user_limit;
        },

        toggleBeta: function (beta, enable) {
            const me = this;

            const options = {
                url: `${me.adminUrl()}/beta/${beta}`
            };

            const action = (enable ? 'update' : 'delete');

            return (me.sync || Backbone.sync).call(me, action, me, options);
        }
    });
});
